import { dxmDirectEmbroideryLogoObjs, dxmLabelColorObjs } from 'src/features/brands/dxm/constants/colors'
import { State, StateObj } from 'src/types'

// 捕球面の刻印
export const dxmEngravedOfCatchFace = (ctx: CanvasRenderingContext2D, catchFace: StateObj, x: number, y: number): void => {
  ctx.lineWidth = 1.5
  const isBright = [
    'black',
    'kBlack',
    'uBlack',
    'jBlack',
    'navy',
    'blue',
    'red',
    'cork',
    'jCork',
    'uCork',
    'kCork',
    'purple',
    'chocolate',
    'green',
    'gray',
    'redOrange'
  ].includes(catchFace.value)
  ctx.strokeStyle = isBright ? '#eee' : '#6d6d6d'
  ctx.beginPath()
  ctx.font = '28px serif'
  ctx.strokeText(`Attack is`, 360 + x, 360 + y)
  ctx.strokeText(`the best form`, 375 + x, 390 + y)
  ctx.strokeText(`of defence`, 425 + x, 420 + y)
  ctx.stroke()
  ctx.closePath()
}

export const dxmLabel = (ctx: CanvasRenderingContext2D, state: State, x: number, y: number, rotate: number, scaleSize: number): void => {
  const isDirectEmbroidery = state.specifyLabel.value === 'directEmbroidery'
  const isLabel = state.specifyLabel.value === 'label'

  ctx.save()
  ctx.rotate((rotate * Math.PI) / 180)
  ctx.scale(scaleSize, scaleSize)

  const labelValue = state.dxmLabel?.value
  const leatherColor = state.listBelt.value
  if (isDirectEmbroidery) {
    const directEmbroidery = dxmDirectEmbroideryLogoObjs.filter((object) => object.value === labelValue)[0]
    const specifiedColor = directEmbroidery?.color || '#fff'
    const coreColor = state.dxmLabelCore?.color
    // D
    labelBase_D(ctx, specifiedColor, x, y)
    labelCore_D(ctx, specifiedColor, coreColor, x, y)
    hollowOutOfLabel_D(ctx, specifiedColor, leatherColor, x, y)
    // x
    labelBase_x(ctx, coreColor, x, y)
    labelCore_x(ctx, specifiedColor, x, y)
    // M
    labelBase_M(ctx, specifiedColor, x, y)
    labelCore_M(ctx, coreColor, x, y)
  }
  if (isLabel) {
    const label = dxmLabelColorObjs.find((o) => o.value === labelValue) || { core: '#eeeeee', edge: '#eeeeee', outOfEdge: '#eeeeee' }
    outerEdgeLabel(ctx, label.outOfEdge, x, y)
    // D
    labelBase_D(ctx, label.edge, x, y)
    labelCore_D(ctx, label.edge, label.core, x, y)
    hollowOutOfLabel_D(ctx, label.outOfEdge, label.outOfEdge, x, y)
    // x
    labelBase_x(ctx, label.core, x, y)
    labelCore_x(ctx, label.edge, x, y)
    // M
    labelBase_M(ctx, label.edge, x, y)
    labelCore_M(ctx, label.core, x, y)
  }
  ctx.restore()
}

// ベースになる黒地部分
const labelBase_D = (ctx: CanvasRenderingContext2D, outOfEdgeColor: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = outOfEdgeColor // '#ccc'
  ctx.beginPath()
  ctx.fillStyle = outOfEdgeColor //'#140C09'
  // D
  ctx.moveTo(359 + x, 571 + y) // 左下1
  ctx.quadraticCurveTo(361 + x, 578 + y, 372 + x, 574 + y) // 左下2
  ctx.quadraticCurveTo(372 + x, 562 + y, 372 + x, 562 + y) //
  ctx.quadraticCurveTo(399 + x, 562 + y, 399 + x, 562 + y) // 右下1
  ctx.quadraticCurveTo(404 + x, 556 + y, 401 + x, 553 + y) // 右下2
  ctx.quadraticCurveTo(375 + x, 534 + y, 354 + x, 510 + y) // 上1
  ctx.quadraticCurveTo(339 + x, 502 + y, 342 + x, 514 + y) // 上2
  ctx.quadraticCurveTo(359 + x, 530 + y, 359 + x, 530 + y) //
  ctx.quadraticCurveTo(359 + x, 549 + y, 359 + x, 549 + y) //
  ctx.quadraticCurveTo(344 + x, 545 + y, 350 + x, 554 + y) // 左
  ctx.quadraticCurveTo(359 + x, 560 + y, 359 + x, 571 + y) // 左下1
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
// ラベルのコアとなる部分
const labelCore_D = (ctx: CanvasRenderingContext2D, edgeColor: string, coreColor: string, x: number, y: number): void => {
  ctx.lineWidth = 1.8
  ctx.strokeStyle = coreColor // '#ccc'
  ctx.beginPath()
  ctx.fillStyle = coreColor
  ctx.moveTo(368 + x, 573 + y) // 下
  ctx.quadraticCurveTo(368 + x, 559 + y, 368 + x, 559 + y)
  ctx.quadraticCurveTo(398 + x, 558 + y, 398 + x, 560 + y) //右1
  ctx.quadraticCurveTo(401 + x, 557 + y, 399 + x, 556 + y) //右2
  ctx.quadraticCurveTo(378 + x, 540 + y, 354 + x, 514 + y) //
  ctx.quadraticCurveTo(340 + x, 508 + y, 343 + x, 513 + y) //
  ctx.quadraticCurveTo(353 + x, 518 + y, 362 + x, 529 + y) //
  ctx.quadraticCurveTo(361 + x, 540 + y, 362 + x, 555 + y) //
  ctx.quadraticCurveTo(351 + x, 548 + y, 351 + x, 555 + y) //
  ctx.quadraticCurveTo(362 + x, 560 + y, 360 + x, 571 + y) //
  ctx.quadraticCurveTo(363 + x, 574 + y, 368 + x, 573 + y) // 下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  ctx.beginPath()
  ctx.fillStyle = edgeColor
  ctx.moveTo(367 + x, 553 + y) // 内＿左下
  ctx.quadraticCurveTo(386 + x, 552 + y, 386 + x, 552 + y) // 内_右下
  ctx.quadraticCurveTo(365 + x, 534 + y, 365 + x, 534 + y) // 内_上
  ctx.quadraticCurveTo(367 + x, 553 + y, 367 + x, 553 + y) // 内_左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// ラベル上のくり抜き部分＿黒地埋め
const hollowOutOfLabel_D = (ctx: CanvasRenderingContext2D, edgeColor: string, leatherColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.1
  ctx.strokeStyle = edgeColor
  ctx.fillStyle = leatherColor
  ctx.beginPath()
  ctx.moveTo(371 + x, 549 + y) // 下
  ctx.quadraticCurveTo(376 + x, 549 + y, 376 + x, 549 + y) //右
  ctx.quadraticCurveTo(369 + x, 543 + y, 369 + x, 543 + y) //上
  ctx.quadraticCurveTo(370 + x, 549 + y, 371 + x, 549 + y) //上
  // 左1番目
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const outerEdgeLabel = (ctx: CanvasRenderingContext2D, fillColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.4
  ctx.strokeStyle = fillColor
  ctx.fillStyle = fillColor
  ctx.beginPath()
  ctx.moveTo(338 + x, 520 + y) // 左上
  ctx.quadraticCurveTo(352 + x, 532 + y, 352 + x, 532 + y)
  ctx.quadraticCurveTo(352 + x, 540 + y, 353 + x, 542 + y) //
  ctx.quadraticCurveTo(340 + x, 540 + y, 343 + x, 555 + y) //
  ctx.quadraticCurveTo(354 + x, 564 + y, 354 + x, 576 + y) // 左下
  ctx.quadraticCurveTo(357 + x, 581 + y, 367 + x, 582 + y) //
  ctx.quadraticCurveTo(377 + x, 579 + y, 377 + x, 573 + y) //
  ctx.quadraticCurveTo(376 + x, 567 + y, 381 + x, 569 + y) //
  ctx.lineTo(403 + x, 568 + y) // xに突入
  ctx.lineTo(413 + x, 575 + y)
  ctx.lineTo(422 + x, 567 + y)
  ctx.lineTo(432 + x, 573 + y)
  ctx.lineTo(439 + x, 567 + y)
  ctx.quadraticCurveTo(448 + x, 579 + y, 459 + x, 565 + y) //
  ctx.quadraticCurveTo(473 + x, 573 + y, 480 + x, 558 + y) //
  ctx.quadraticCurveTo(493 + x, 570 + y, 502 + x, 552 + y) // 右下
  ctx.quadraticCurveTo(494 + x, 533 + y, 495 + x, 506 + y) // 右上
  ctx.quadraticCurveTo(489 + x, 491 + y, 470 + x, 506 + y) //
  ctx.quadraticCurveTo(454 + x, 502 + y, 445 + x, 520 + y) //
  ctx.quadraticCurveTo(431 + x, 524 + y, 432 + x, 532 + y) // m終了
  ctx.lineTo(423 + x, 527 + y)
  ctx.lineTo(417 + x, 535 + y)
  ctx.lineTo(405 + x, 527 + y)
  ctx.lineTo(395 + x, 540 + y)
  ctx.quadraticCurveTo(380 + x, 529 + y, 357 + x, 505 + y) //
  ctx.quadraticCurveTo(345 + x, 498 + y, 340 + x, 502 + y) //
  ctx.quadraticCurveTo(330 + x, 508 + y, 338 + x, 520 + y) //

  // 左1番目
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// x
const labelBase_x = (ctx: CanvasRenderingContext2D, outOfEdgeColor: string, x: number, y: number): void => {
  ctx.lineWidth = 0.5
  ctx.strokeStyle = outOfEdgeColor
  ctx.beginPath()
  ctx.fillStyle = outOfEdgeColor // '#140C09'
  // D
  ctx.moveTo(414 + x, 568 + y) // 左下
  ctx.quadraticCurveTo(422 + x, 559 + y, 422 + x, 559 + y)
  ctx.quadraticCurveTo(431 + x, 566 + y, 431 + x, 566 + y) // 右下
  ctx.quadraticCurveTo(441 + x, 557 + y, 441 + x, 557 + y)
  ctx.quadraticCurveTo(429 + x, 549 + y, 429 + x, 549 + y)
  ctx.quadraticCurveTo(436 + x, 540 + y, 436 + x, 540 + y) // 右上
  ctx.quadraticCurveTo(424 + x, 533 + y, 424 + x, 533 + y)
  ctx.quadraticCurveTo(417 + x, 542 + y, 417 + x, 542 + y)
  ctx.quadraticCurveTo(406 + x, 534 + y, 406 + x, 534 + y) // 左上
  ctx.quadraticCurveTo(398 + x, 544 + y, 398 + x, 544 + y)
  ctx.quadraticCurveTo(409 + x, 551 + y, 409 + x, 551 + y)
  ctx.quadraticCurveTo(403 + x, 559 + y, 403 + x, 559 + y)
  ctx.quadraticCurveTo(414 + x, 568 + y, 414 + x, 568 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// // ラベルのコアとなる部分
const labelCore_x = (ctx: CanvasRenderingContext2D, coreColor: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = coreColor // '#ccc'
  ctx.beginPath()
  ctx.fillStyle = coreColor
  ctx.moveTo(413 + x, 564 + y) // 左下
  ctx.quadraticCurveTo(419 + x, 556 + y, 419 + x, 556 + y)
  ctx.quadraticCurveTo(430 + x, 562 + y, 430 + x, 562 + y) // 右下
  ctx.quadraticCurveTo(437 + x, 557 + y, 437 + x, 557 + y)
  ctx.quadraticCurveTo(426 + x, 550 + y, 426 + x, 550 + y)
  ctx.quadraticCurveTo(432 + x, 541 + y, 432 + x, 541 + y) // 右上
  ctx.quadraticCurveTo(424 + x, 536 + y, 424 + x, 536 + y)
  ctx.quadraticCurveTo(417 + x, 544 + y, 417 + x, 544 + y)
  ctx.quadraticCurveTo(406 + x, 538 + y, 406 + x, 538 + y) // 左上
  ctx.quadraticCurveTo(402 + x, 544 + y, 402 + x, 544 + y)
  ctx.quadraticCurveTo(411 + x, 550 + y, 411 + x, 550 + y)
  ctx.quadraticCurveTo(405 + x, 559 + y, 405 + x, 559 + y)
  ctx.quadraticCurveTo(413 + x, 564 + y, 413 + x, 564 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// M
const labelBase_M = (ctx: CanvasRenderingContext2D, outOfEdgeColor: string, x: number, y: number): void => {
  ctx.lineWidth = 0.5
  ctx.strokeStyle = outOfEdgeColor // '#ccc'
  ctx.beginPath()
  ctx.fillStyle = outOfEdgeColor // '#140C09'
  ctx.moveTo(445 + x, 565 + y) // 左下
  ctx.quadraticCurveTo(451 + x, 567 + y, 454 + x, 562 + y)
  ctx.quadraticCurveTo(457 + x, 540 + y, 459 + x, 540 + y)
  ctx.quadraticCurveTo(457 + x, 547 + y, 462 + x, 558 + y)
  ctx.quadraticCurveTo(473 + x, 566 + y, 475 + x, 555 + y)
  ctx.quadraticCurveTo(475 + x, 539 + y, 478 + x, 535 + y)
  ctx.quadraticCurveTo(479 + x, 543 + y, 482 + x, 548 + y)
  ctx.quadraticCurveTo(482 + x, 553 + y, 487 + x, 556 + y)
  ctx.quadraticCurveTo(495 + x, 558 + y, 495 + x, 550 + y)
  ctx.quadraticCurveTo(487 + x, 520 + y, 490 + x, 513 + y)
  ctx.quadraticCurveTo(493 + x, 505 + y, 484 + x, 504 + y)
  ctx.quadraticCurveTo(477 + x, 505 + y, 474 + x, 510 + y)
  ctx.quadraticCurveTo(467 + x, 527 + y, 467 + x, 527 + y)
  ctx.quadraticCurveTo(471 + x, 512 + y, 466 + x, 512 + y)
  ctx.quadraticCurveTo(459 + x, 509 + y, 452 + x, 518 + y)
  ctx.quadraticCurveTo(449 + x, 529 + y, 449 + x, 529 + y)
  ctx.quadraticCurveTo(441 + x, 524 + y, 437 + x, 532 + y)
  ctx.quadraticCurveTo(436 + x, 552 + y, 445 + x, 565 + y) //左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// ラベルのコアとなる部分
const labelCore_M = (ctx: CanvasRenderingContext2D, coreColor: string, x: number, y: number): void => {
  ctx.lineWidth = 1.8
  ctx.strokeStyle = coreColor // '#ccc'
  ctx.beginPath()
  ctx.fillStyle = coreColor
  ctx.moveTo(446 + x, 562 + y) // 左下
  ctx.quadraticCurveTo(449 + x, 565 + y, 452 + x, 561 + y)
  ctx.quadraticCurveTo(450 + x, 548 + y, 459 + x, 531 + y)
  ctx.quadraticCurveTo(459 + x, 542 + y, 466 + x, 558 + y)
  ctx.quadraticCurveTo(469 + x, 561 + y, 472 + x, 557 + y)
  ctx.quadraticCurveTo(470 + x, 545 + y, 479 + x, 523 + y)
  ctx.quadraticCurveTo(480 + x, 538 + y, 486 + x, 550 + y)
  ctx.quadraticCurveTo(485 + x, 554 + y, 491 + x, 555 + y) // 右下
  ctx.quadraticCurveTo(495 + x, 553 + y, 493 + x, 548 + y)
  ctx.quadraticCurveTo(483 + x, 516 + y, 488 + x, 511 + y) // 右上
  ctx.quadraticCurveTo(487 + x, 507 + y, 485 + x, 507 + y)
  ctx.quadraticCurveTo(480 + x, 507 + y, 477 + x, 513 + y)
  ctx.quadraticCurveTo(472 + x, 525 + y, 467 + x, 544 + y)
  ctx.quadraticCurveTo(462 + x, 528 + y, 466 + x, 517 + y)
  ctx.quadraticCurveTo(460 + x, 513 + y, 458 + x, 518 + y)
  ctx.quadraticCurveTo(450 + x, 534 + y, 448 + x, 554 + y)
  ctx.quadraticCurveTo(448 + x, 547 + y, 448 + x, 547 + y)
  ctx.quadraticCurveTo(445 + x, 540 + y, 448 + x, 536 + y)
  ctx.quadraticCurveTo(449 + x, 529 + y, 444 + x, 531 + y)
  ctx.quadraticCurveTo(440 + x, 534 + y, 441 + x, 541 + y)
  ctx.quadraticCurveTo(440 + x, 551 + y, 446 + x, 562 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
